// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectDialogCreatedMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_NEWDIALOGCREATED)
    this.DialogId = 0
    this.Pin = null
}

DirectDialogCreatedMessage.prototype = Object.create(DirectMessageBase.prototype)